import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class Reason {
	public Value: string;
}

export class AssetPandaExport implements ObjectSerializer {

	public EnableExport: boolean;

	public TargetServerApiURL: string;
	public TargetServerUsername: string;
	public TargetServerPassword: string;
	public BuildingName: string;
	public RoomName: string;

	public ExportOrigin: string;

	public ExportDevices: boolean;
	public ExportConfigs: boolean;

	public get HasTargetServerApiURL(): boolean {
		return !!this.TargetServerApiURL;
	}

	public get HasTargetServerUsername(): boolean {
		return !!this.TargetServerUsername;
	}

	public get HasTargetServerPassword(): boolean {
		return !!this.TargetServerPassword;
	}

	public get HasBuildingName(): boolean {
		return !!this.BuildingName;
	}

	public get HasRoomName(): boolean {
		return !!this.RoomName;
	}

	public get HasExportOrigin(): boolean {
		return !!this.ExportOrigin;
	}

	constructor() {
		this.Clear();
	}

	public Copy(other: AssetPandaExport): void {
		this.Clear();

		this.EnableExport = other.EnableExport;

		this.TargetServerApiURL = other.TargetServerApiURL;
		this.TargetServerUsername = other.TargetServerUsername;
		this.TargetServerPassword = other.TargetServerPassword;
		this.BuildingName = other.BuildingName;
		this.RoomName = other.RoomName;

		this.ExportOrigin = other.ExportOrigin;

		this.ExportDevices = other.ExportDevices;
		this.ExportConfigs = other.ExportConfigs;
	}

	public Clear(): void {
		this.EnableExport = false;

		this.TargetServerApiURL = "";
		this.TargetServerUsername = "";
		this.TargetServerPassword = "";
		this.BuildingName = "";
		this.RoomName = "";

		this.ExportOrigin = "agent";

		this.ExportDevices = false;
		this.ExportConfigs = false;
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof AssetPandaExport))
			return false;
		var other = (obj as AssetPandaExport);

		return (
			this.EnableExport == other.EnableExport &&

			this.TargetServerApiURL == other.TargetServerApiURL &&
			this.TargetServerUsername == other.TargetServerUsername &&
			this.TargetServerPassword == other.TargetServerPassword &&
			this.BuildingName == other.BuildingName &&
			this.RoomName == other.RoomName &&

			this.ExportOrigin == other.ExportOrigin &&

			this.ExportDevices == other.ExportDevices &&
			this.ExportConfigs == other.ExportConfigs);
	}

	public IsValid(reason: Reason): boolean {
		reason.Value = "";

		if (this.EnableExport) {
			if (!this.HasTargetServerApiURL) {
				reason.Value = "The AssetPanda API URL must be selected";
				return false;
			}
			if (!this.HasTargetServerUsername) {
				reason.Value = "The AssetPanda API username must be specified";
				return false;
			}
			if (!this.HasTargetServerPassword) {
				reason.Value = "The AssetPanda API password must be specified";
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	public Write(obj: any, context: any): void {
		obj.assetpanda_export = {};
		obj = obj.assetpanda_export;

		obj.enable_export = ValueEncoder.EncodeBoolean(this.EnableExport);

		if (this.HasTargetServerApiURL)
			obj.target_server_api_url = this.TargetServerApiURL;
		if (this.HasTargetServerUsername)
			obj.target_server_username = this.TargetServerUsername;
		if (this.HasTargetServerPassword)
			obj.target_server_password = this.TargetServerPassword;
		if (this.HasBuildingName)
			obj.building_name = this.BuildingName;
		if (this.HasRoomName)
			obj.room_name = this.RoomName;

		if (this.HasExportOrigin)
			obj.export_origin = this.ExportOrigin;

		obj.export_devices = ValueEncoder.EncodeBoolean(this.ExportDevices);
		obj.export_configs = ValueEncoder.EncodeBoolean(this.ExportConfigs);
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.assetpanda_export)
			throw new Error();
		obj = obj.assetpanda_export;

		if (obj.enable_export !== undefined)
			this.EnableExport = ValueEncoder.DecodeBoolean(obj.enable_export);

		if (obj.target_server_api_url !== undefined)
			this.TargetServerApiURL = obj.target_server_api_url;
		if (obj.target_server_username !== undefined)
			this.TargetServerUsername = obj.target_server_username;
		if (obj.target_server_password !== undefined)
			this.TargetServerPassword = obj.target_server_password;
		if (obj.building_name !== undefined)
			this.BuildingName = obj.building_name;
		if (obj.room_name !== undefined)
			this.RoomName = obj.room_name;

		if (obj.export_origin !== undefined)
			this.ExportOrigin = obj.export_origin;

		if (obj.export_devices !== undefined)
			this.ExportDevices = ValueEncoder.DecodeBoolean(obj.export_devices);
		if (obj.export_configs !== undefined)
			this.ExportConfigs = ValueEncoder.DecodeBoolean(obj.export_configs);
	}

}